import backgroundVideo from '../images/homepage.mp4'
import './Locations.css'

export default function Locations(){
    const address = "4443 Cane Run Rd #210, Louisville, KY 40216";

    return <>
    <div className='page'>
    <video autoPlay loop muted playsInline className="background-video">
        <source src={backgroundVideo} type="video/mp4" />
    </video>
    <div className='content_in_loc'>
    <h1 className='title'>Located at</h1>
    <h1 className='title'>4443 Cane Run Rd</h1>
    <h1 className='title'>Unit #210</h1>
    </div>
    <div className='map'>
    <a
        href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`}
        target="_blank"
        rel="noopener noreferrer"
        className='mapData'>
        <iframe
            title="Google Map"
            width="70%"
            height="400"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            src={`https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`}
        ></iframe>
        </a>
    </div>
    </div>
    </>

}